import React, { Fragment, ReactElement } from 'react';
import FormatService from '../../services/format-service';
import Button from '../button/button.component';
import useStylesControlButton from './control-button.styles';

const ControlButton: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isIconButton,
    isModal,
    isDisabled,
    isActive,
    icon,
    onClick,
    children,
  } = props;

  const { classes } = useStylesControlButton();

  const modalClassName: string | undefined = isModal ? classes.controlButtonModal : undefined;
  const activeClassName: string | undefined = isActive ? classes.controlButtonActive : undefined;
  const disabledClassName: string | undefined = isDisabled ? classes.controlButtonDisabled : undefined;

  return (
    <Fragment>
      {
        isIconButton ? (
          <Button
            isText
            isDefault
            isDisabled={isDisabled}
            className={classes.controlButtonIcon}
            onClick={onClick}
          >
            {icon}
            <div className={classes.controlButtonIconLabel}>
              {children}
            </div>
          </Button>
        ) : (
          <Button
            isDefault
            isActive={isActive}
            isDisabled={isDisabled}
            className={FormatService.formatClassNames(
              classes.controlButton, modalClassName, activeClassName, disabledClassName,
            )}
            onClick={onClick}
          >
            {children}
          </Button>
        )
      }
    </Fragment>
  );
});

export default ControlButton;
